<script setup lang="ts">
defineProps<{
  image: string;
  name: string;
  title: string;
  company: string;
}>();
</script>

<template>
  <div class="le-person-spotlight">
    <img alt="" :src="image" class="le-person-spotlight__image" />
    <p class="le-person-spotlight__text le-person-spotlight__text--main">{{ name }}</p>
    <p class="le-person-spotlight__text">{{ title }}</p>
    <p class="le-person-spotlight__text">{{ company }}</p>
  </div>
</template>

<style lang="less" scoped>
@import "@fontsource/montserrat/700.css";

.le-person-spotlight {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  &__image {
    margin-bottom: 8px;
  }

  &__text {
    margin: 0;
    font-size: 0.875rem;
    line-height: 20px;

    &--main {
      margin-bottom: 8px;
      color: #082f65;
      font-family: Montserrat, sans-serif;
      font-weight: 700;
    }
  }
}
</style>
